import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({ title, description }) => {
  const { site, profileData } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
          siteUrl
          author
          twitterUsername
          image
        }
      }
      profileData {
        name
        title
        bio
        location
        social_links {
          platform
          url
        }
        skills {
          name
        }
      }
    }
  `)

  const { siteMetadata } = site
  const pageTitle = title || siteMetadata.title
  const pageDescription = description || siteMetadata.description

  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": profileData.name,
    "url": siteMetadata.siteUrl,
    "jobTitle": profileData.title,
    "description": profileData.bio,
    "sameAs": profileData.social_links.map(l => l.url),
    "knowsAbout": profileData.skills.map(s => s.name),
  }

  return (
    <Helmet htmlAttributes={{ lang: "en" }}>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteMetadata.siteUrl} />
      <meta property="og:image" content={`${siteMetadata.siteUrl}${siteMetadata.image}`} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={siteMetadata.twitterUsername} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />

      {/* Machine-readable profile link */}
      <link rel="alternate" type="application/json" href="/api/profile.json" />

      {/* JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(personSchema)}
      </script>
    </Helmet>
  )
}

export default SEO
